import { schema } from 'prose-core'
import { insertAndFocus } from 'common/Prose/utils/insertAndFocus'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { SingleMenuDropdownContext } from 'common/Prose/Toolbar/ToolbarBravo/SingleMenuDropdown/SingleMenuDropdownStore'
import { useContext } from 'react'
import { SingleMenuDropdownItem } from 'common/Prose/Toolbar/ToolbarBravo/SingleMenuDropdown/SingleMenuDropdownItem'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'

export const InsertTableOfContents = () => {
  const view = useEditorView()
  const hasNewBar = useFlipperFlag('new_inline_format_bar')
  const dropdownStore = useContext(SingleMenuDropdownContext)

  if (!hasNewBar || !view.state.schema.nodes.table_of_contents) return null

  const insertTableOfContents = () => {
    const node = schema.nodes.table_of_contents.createAndFill({})
    if (!node) {
      throw new Error(`Failed to create table_of_contents node`)
    }
    insertAndFocus(view, node)
    dropdownStore?.hardClose()
  }

  return (
    <SingleMenuDropdownItem
      icon={<ToolbarIcon name={IconName.Menu2} />}
      label="Table of Contents"
      handleClick={insertTableOfContents}
    />
  )
}
